var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1900_23518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 4.6875C19.6128 4.6875 14.4462 6.82756 10.6369 10.6369C6.82756 14.4462 4.6875 19.6128 4.6875 25C4.6875 30.3872 6.82756 35.5538 10.6369 39.3631C14.4462 43.1724 19.6128 45.3125 25 45.3125C30.3872 45.3125 35.5538 43.1724 39.3631 39.3631C43.1724 35.5538 45.3125 30.3872 45.3125 25C45.3125 19.6128 43.1724 14.4462 39.3631 10.6369C35.5538 6.82756 30.3872 4.6875 25 4.6875ZM25 50C18.3696 50 12.0107 47.3661 7.32233 42.6777C2.63392 37.9893 0 31.6304 0 25C0 18.3696 2.63392 12.0107 7.32233 7.32233C12.0107 2.63392 18.3696 0 25 0C31.6304 0 37.9893 2.63392 42.6777 7.32233C47.3661 12.0107 50 18.3696 50 25C50 31.6304 47.3661 37.9893 42.6777 42.6777C37.9893 47.3661 31.6304 50 25 50ZM35.2539 28.2227L26.6602 36.8164C25.7422 37.7344 24.2578 37.7344 23.3496 36.8164L14.7559 28.2227C13.8379 27.3047 13.8379 25.8203 14.7559 24.9121C15.6738 24.0039 17.1582 23.9941 18.0664 24.9121L22.6562 29.502V14.8438C22.6562 13.5449 23.7012 12.5 25 12.5C26.2988 12.5 27.3438 13.5449 27.3438 14.8438V29.502L31.9336 24.9121C32.8516 23.9941 34.3359 23.9941 35.2441 24.9121C36.1523 25.8301 36.1621 27.3145 35.2441 28.2227H35.2539Z",
    fill: "#94AAC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1900_23518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowDown);
export default __webpack_public_path__ + "static/media/circle-arrow-down.7bff68520c909c30b9a9bd11f7487bd0.svg";
export { ForwardRef as ReactComponent };